var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 35,
    viewBox: "0 0 26 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 0.25C5.64453 0.25 0 5.96094 0 13C0 18.1797 1.72656 19.6406 11.4219 33.5859C11.7539 34.0508 12.2188 34.25 12.75 34.25C13.2148 34.25 13.6797 34.0508 14.0117 33.5859C23.707 19.6406 25.5 18.1797 25.5 13C25.5 5.96094 19.7891 0.25 12.75 0.25ZM12.75 29.8672C11.5547 28.207 10.4922 26.6797 9.5625 25.418C3.78516 17.1836 3.1875 16.1211 3.1875 13C3.1875 7.75391 7.4375 3.4375 12.75 3.4375C17.9961 3.4375 22.3125 7.75391 22.3125 13C22.3125 16.1211 21.6484 17.1836 15.8711 25.418C14.9414 26.6797 13.8789 28.207 12.75 29.8672ZM12.75 7.6875C9.76172 7.6875 7.4375 10.0781 7.4375 13C7.4375 15.9883 9.76172 18.3125 12.75 18.3125C15.6719 18.3125 18.0625 15.9883 18.0625 13C18.0625 10.0781 15.6719 7.6875 12.75 7.6875ZM12.75 15.125C11.5547 15.125 10.625 14.1953 10.625 13C10.625 11.8711 11.5547 10.875 12.75 10.875C13.8789 10.875 14.875 11.8711 14.875 13C14.875 14.1953 13.8789 15.125 12.75 15.125Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.2d86b84412b0bb0b414e9217c3d470f7.svg";
export { ForwardRef as ReactComponent };